module.exports = {
  title: "blueDigital",
  fixedHeader: true,
  sidebarLogo: true,
  useDarkTheme: true,
};
